import BaseService from '@Core/axios/BaseService'
// import { CORE_BE_API_URL } from 'env'
class CoreMyChannelService extends BaseService {
	BASE_URL = 'https://gw-core-service.eduquiz.io.vn'

	constructor(props) {
		super(props)
		this.setRequest()
	}

	switchLms = data => {
		const endpoint = `${this.BASE_URL}/api/public/v1/auth/switch-bizapp-lms?telescope=1`
		return this.request.post(endpoint, data)
	}
}

const coreMyChannelService = new CoreMyChannelService()

export default coreMyChannelService
